export default __webpack_public_path__ + "images/calendar.76f08062e4fcab7ebacba667ce6dd43b.png";